import type { FC } from "react";
import { useSelector } from "react-redux";
import { Margin } from "@kivra/react-components";
import { LinkButton } from "../atoms/LinkButton";
import { ButtonContainer } from "../layouts/ButtonContainer";
import { useCopy } from "../../utils/globalContext";
import { routes } from "../../utils/routes";
import type { RootState } from "../../store/rootReducer";
import { getTunnistusData } from "../../store/auth";
import { KivraHeaderRouter } from "../header/KivraHeaderRouter";
import { PresetFormValue } from "./PresetFormValue";

export const SignupTooYoung: FC = () => {
  const copy = useCopy();
  const { ssn, lastName, givenName } = useSelector((state: RootState) => ({
    ssn: getTunnistusData(state).ssn,
    lastName: getTunnistusData(state).lastName,
    givenName: getTunnistusData(state).givenName,
  }));
  return (
    <div style={{ minWidth: "250px" }}>
      <KivraHeaderRouter />
      <PresetFormValue
        label={copy("input_placeholder_finland_ssn")}
        value={ssn}
      />
      <Margin bottom={20} />
      <PresetFormValue
        label={copy("input_placeholder__name")}
        value={`${givenName} ${lastName}`}
      />
      <ButtonContainer>
        <LinkButton to={routes.ROOT} dataTestId="back-button">
          {copy("btn__backward")}
        </LinkButton>
      </ButtonContainer>
    </div>
  );
};
